document.addEventListener('DOMContentLoaded', function () {

    // Wait for element(s) to appear in DOM, then apply actions
    window.waitFor = function (selector, actions) {
        const applyActions = (el) => {
            if (actions.attr) {
                Object.entries(actions.attr).forEach(([name, val]) => {
                    el.setAttribute(name, val);
                });
            }
            if (actions.addClass) {
                el.classList.add(...(Array.isArray(actions.addClass) ? actions.addClass : [actions.addClass]));
            }
            if (actions.callback) {
                actions.callback(el);
            }
        };

        // Check if elements already exist
        const existing = document.querySelectorAll(selector);
        if (existing.length > 0) {
            existing.forEach(applyActions);
            return;
        }

        // Watch for elements to be added
        const processedElements = new Set();
        const obs = new MutationObserver((mutations, observer) => {
            const elements = document.querySelectorAll(selector);
            elements.forEach(el => {
                if (!processedElements.has(el)) {
                    applyActions(el);
                    processedElements.add(el);
                }
            });
        });
        obs.observe(document.body, { childList: true, subtree: true });
    };

    // Function to change the tag of elements for accessibility purposes
    window.changeTagForA11Y = function (selector, newTag) {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
            const newElement = document.createElement(newTag);
            Array.from(element.attributes).forEach(attr => {
                newElement.setAttribute(attr.name, attr.value);
            });
            newElement.innerHTML = element.innerHTML;
            element.parentNode.replaceChild(newElement, element);
        });
    };

    // Global focus trap function for modals
    window.trapFocus = function (selector, options = {}) {
        const element = typeof selector === 'string' ? document.querySelector(selector) : selector;
        if (!element) return;

        // Store the element that triggered the trap
        const triggerElement = options.returnFocus !== false ? document.activeElement : null;

        const focusableElements = element.querySelectorAll(
            'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        );

        if (focusableElements.length === 0) return;

        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        const handleTab = (e) => {
            if (e.key !== 'Tab') return;

            if (e.shiftKey) {
                if (document.activeElement === firstFocusable) {
                    e.preventDefault();
                    lastFocusable.focus();
                }
            } else {
                if (document.activeElement === lastFocusable) {
                    e.preventDefault();
                    firstFocusable.focus();
                }
            }
        };

        element.addEventListener('keydown', handleTab);
        firstFocusable.focus();

        // Return cleanup function that restores focus
        return () => {
            element.removeEventListener('keydown', handleTab);
            if (triggerElement && options.returnFocus !== false) {
                triggerElement.focus();
            }
        };
    };

    const searchDrawer = document.querySelector('.search-drawer');
    const footerSection = document.querySelector('.shopify-section.footer-section');

    if (searchDrawer && footerSection) {
        footerSection.after(searchDrawer);
    }

    // Marquee Play/Pause Accessibility
    const marquees = document.querySelectorAll('.marquee');

    marquees.forEach(function (marquee, index) {
        // Check if button already exists to avoid duplicates
        if (marquee.querySelector('.marquee-toggle')) {
            return;
        }

        // Create play/pause button
        const toggleBtn = document.createElement('button');
        toggleBtn.type = 'button';
        toggleBtn.className = 'marquee-toggle';
        toggleBtn.setAttribute('aria-pressed', 'false');
        toggleBtn.setAttribute('aria-label', 'Pause animation');

        // Add play and pause icons (SVG)
        toggleBtn.innerHTML = `
            <svg class="pause-icon" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <rect x="6" y="4" width="4" height="16"></rect>
                <rect x="14" y="4" width="4" height="16"></rect>
            </svg>
            <svg class="play-icon" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <polygon points="5,3 19,12 5,21"></polygon>
            </svg>
        `;

        // Insert button at start of marquee using prepend (more reliable)
        marquee.prepend(toggleBtn);

        // Toggle functionality
        toggleBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            const isPaused = marquee.classList.toggle('paused');
            toggleBtn.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
            toggleBtn.setAttribute('aria-label', isPaused ? 'Play animation' : 'Pause animation');
        });
    });

    const splideSlide = document.querySelectorAll('.splide__slide');
    splideSlide.forEach(function (slide) {
        slide.removeAttribute('role');
    });

    const mainProductTitle = document.querySelector('.main-product__title');
    const thumbSplideSlide = document.querySelectorAll('.splide__slide[id^="thumbnail-"]');
    thumbSplideSlide.forEach(function (slide) {
        const thumbOf = slide.getAttribute('aria-label');
        const imgAlt = thumbOf ? `${mainProductTitle.textContent} - Thumbnail ${thumbOf}` : mainProductTitle.textContent;
        const img = slide.querySelector('img');
        if (img) {
            img.setAttribute('alt', imgAlt);
        }
    });

    const looxRatingLabel = document.querySelectorAll('.loox-rating-label');
    looxRatingLabel.forEach(function (label) {
        label.removeAttribute('aria-hidden');
    });

    const tolstoyCarousel = document.querySelector('.tolstoy-carousel');
    if (tolstoyCarousel) {
        const tileContainers = tolstoyCarousel.querySelectorAll('.tolstoy-carousel-tile-container');
        const totalTiles = tileContainers.length;

        tileContainers.forEach(function (container, index) {
            const button = container.querySelector('button');
            if (button) {
                const currentLabel = button.getAttribute('aria-label') || '';
                button.setAttribute('aria-label', `${currentLabel} ${index + 1} of ${totalTiles}`.trim());
            }
        });
    }

    window.trapFocus('#popup-content');

    const closePopupBtn = document.getElementById('close-popup-btn');
    const openCustomFormBtns = document.querySelectorAll('.open-customform');

    openCustomFormBtns.forEach(function (openBtn) {
        if (closePopupBtn) {
            openBtn.addEventListener('click', function () {
                const triggerBtn = this;
                setTimeout(() => {
                    closePopupBtn.focus();
                }, 100);

                // Store reference to the trigger button for returning focus
                closePopupBtn.dataset.triggerBtn = Array.from(openCustomFormBtns).indexOf(triggerBtn);
            });
        }
    });

    if (closePopupBtn) {
        closePopupBtn.addEventListener('click', function () {
            const triggerIndex = parseInt(closePopupBtn.dataset.triggerBtn);
            if (!isNaN(triggerIndex) && openCustomFormBtns[triggerIndex]) {
                openCustomFormBtns[triggerIndex].focus();
            }
        });
    }

    const ppButtonEnter = document.querySelector('.pp-button-enter');
    const ppTrackingResultTitle = document.querySelector('.pp-tracking-result-title');
    if (ppButtonEnter) {
        ppButtonEnter.addEventListener('submit', function () {
            const ppTrackingResultTitleInterval = setInterval(() => {
                if (ppTrackingResultTitle) {
                    window.changeTagForA11Y(ppTrackingResultTitle, 'h2');
                    clearInterval(ppTrackingResultTitleInterval);
                }
            }, 300);
        });
    }

    // Add aria-label to Instagram embeds on blog article pages
    if (window.location.pathname.includes('/blogs/news/') && document.body.classList.contains('template_article')) {

        const instagramEmbeds = document.querySelectorAll('[data-instgrm-payload-id]');
        instagramEmbeds.forEach(function (embed) {
            embed.setAttribute('aria-label', 'Instagram Profile');
        });

        // Add list roles to bloggle slider for accessibility
        const bloggleSliders = document.querySelectorAll('.bggle--slider');
        bloggleSliders.forEach(function (slider) {
            slider.setAttribute('role', 'list');
        });

        const bloggleProductContainers = document.querySelectorAll('.bggle_product-container');
        bloggleProductContainers.forEach(function (container) {
            container.setAttribute('role', 'listitem');
        });

        // Add aria-label to bloggle product buttons and fix accessibility
        const bloggleButtonLinks = document.querySelectorAll('.bggle_button-link');
        bloggleButtonLinks.forEach(function (link) {
            const href = link.getAttribute('href');
            const productTitle = link.querySelector('.bloggle_product--title');
            const button = link.querySelector('button');

            // Set href and aria-label on button before converting
            if (productTitle && button) {
                const titleText = productTitle.textContent.trim();
                const buttonText = button.textContent.trim();
                button.setAttribute('aria-label', `${buttonText} - ${titleText}`);
                button.setAttribute('href', href);
            }
        });

        // Change .bggle_button-link from a to div and button to a
        window.changeTagForA11Y('.bggle_button-link', 'div');
        window.changeTagForA11Y('.bggle_button-link button', 'a');

        // Add click handler and cursor to converted divs
        const convertedDivs = document.querySelectorAll('div.bggle_button-link');
        convertedDivs.forEach(function (div) {
            const href = div.querySelector('a')?.getAttribute('href');
            if (href) {
                div.style.cursor = 'pointer';
                div.addEventListener('click', function (e) {
                    if (e.target.tagName !== 'A') {
                        window.location.href = href;
                    }
                });
            }
        });

    }

    if (window.location.pathname.includes('/pages/reviews') && document.body.classList.contains('template_page-youtube-videos')) {
        // Update aria-label for Tolstoy play buttons
        const tolstoyVideosCarouselContainer = document.querySelectorAll('.tolstoy-video-carousel-container');
        tolstoyVideosCarouselContainer.forEach(function (tolstoyVideo) {
            const tolstoyPrevBtn = tolstoyVideo.querySelector('.tolstoy-previous-button');
            const tolstoyNextBtn = tolstoyVideo.querySelector('.tolstoy-next-button');
            const tolstoyPlayButtons = tolstoyVideo.querySelectorAll('.tolstoy-play-button-container');
            if (tolstoyPrevBtn) {
                tolstoyPrevBtn.setAttribute('aria-label', 'Previous reviews');
            }
            if (tolstoyNextBtn) {
                tolstoyNextBtn.setAttribute('aria-label', 'Next reviews');
            }
            tolstoyPlayButtons.forEach(function (tolstoyPlayButton) {
                const btnSvg = tolstoyPlayButton.querySelector('svg');
                if (btnSvg) {
                    btnSvg.setAttribute('role', 'presentation');
                }
                const currentLabel = tolstoyPlayButton.getAttribute('aria-label') || '';
                if (currentLabel.includes('Open Tolstoy widget')) {
                    const newLabel = currentLabel.replace('Open Tolstoy widget', 'Play Icecartel Jewelry Video Reviews');
                    tolstoyPlayButton.setAttribute('aria-label', newLabel);
                }
            });
        });
    }

    // Select all .footer-column elements
    const footerColumns = document.querySelectorAll('.footer-column');

    // Get the last two columns
    if (footerColumns.length >= 2) {
    const secondLastColumn = footerColumns[footerColumns.length - 2];
    const lastColumn = footerColumns[footerColumns.length - 1];
    
    // Create images for both columns
    [secondLastColumn, lastColumn].forEach(column => {
        const imgLink = document.createElement('a');
        const img = document.createElement('img');
        imgLink.href = 'https://accessdesignstudio.com/';
        imgLink.target = '_blank';
        img.src = 'https://cdn.shopify.com/s/files/1/0679/4461/2161/files/Accessibility_Compliance_Badge_JAN_2026.png';
        img.alt = 'ACCESS DESIGN STUDIO CERTIFIED ACCESSIBLE WEBSITE JAN 2026';
        img.classList.add('ADS-ComBadge');
        
        // Append the img to the link and link to column
        imgLink.appendChild(img);
        column.appendChild(imgLink);
    });
    }

    // Remove a tags with empty href in .shopify-policy__body and unwrap their text content
    const policyBody = document.querySelector('.shopify-policy__body');
    if (policyBody) {
        const linksWithEmptyHref = policyBody.querySelectorAll('a[href=""], a:not([href])');
        linksWithEmptyHref.forEach(function (link) {
            const textNode = document.createTextNode(link.textContent);
            link.parentNode.replaceChild(textNode, link);
        });
    }

});